import React from "react";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "util/asyncComponent";
const Transaction = ({ match }) => (
    <Switch>
        <Route exact path={`${match.url}/list`} component={asyncComponent(() => import('../../components/User/ListTransaction'))} />

    </Switch>
)

export default Transaction;